module.exports = __webpack_public_path__ + "img/roman2.65ed819b.png";